/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  defaultLimitPagination,
  get,
  riskProfile,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { useLocation } from "react-router-dom";
import {
  formatMobile,
  formatName,
  formatPhone,
  getModuleNamingBySlug,
} from "../../../lib/Misc";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../../components/Pagination";
import { debounce } from "lodash";
import MainBody from "../../../components/MainBody/MainBody";
import sortCaret from "../../../components/SortCaret";
import { useTrust } from "../../../lib/context/TrustContext";
import { Button } from "../../../components/ui/button";
import { CalendarCheck, CheckCircle2, Clock, SearchCheck } from "lucide-react";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import ExpandCDD from "./ExpandCDD";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import VerifyModal from "./VerifyModal";
import RiskChange from "./RiskChange";
import UnauthorisedAccess from "../../../UnauthorisedAccess";
import AddEditContact from "../../Contacts/AddEditContact";
import { AMLCTFModuleConditonIndustry } from "../../../lib/PermissionConditions";
import { useUser } from "../../../lib/context/UserContext";
import AddEditVendor from "../../Vendors/AddEditVendor";
import CDDVerifyModal from "../../../components/Assessment_KYC/CDDVerifyModal";
import CDDVerifyCheck from "../../../components/Assessment_KYC/CDDVerifyCheck";
import KYBReportDownload from "../../../components/Assessment_KYC/KYBReportDownload";
import AdverseMedia from "../../../components/Assessment_KYC/AdverseMedia";
import CDDStatus from "../../../components/Assessment_KYC/CDDStatus";

// * Start: Vendor Listing Page
const SimplifiedCDD = ({ sectionType, readAccess, writeAccess }) => {
  // * Start: Url Management State
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const { organizationData } = useOrganization();
  const { userData } = useUser();

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;

  // * End: Url Management State

  // * Start: List Management State

  const { trustId } = useTrust();
  const [simplifiedCDDsList, setSimplifiedCDDsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [cddId, setCddId] = useState("");
  const [cddItem, setCddItem] = useState("");

  const [showVisual, setShowVisual] = useState(false);
  const [showRisk, setShowRisk] = useState(false);

  const [edit, setEdit] = useState(false);
  const [onlyKyc, setOnlyKyc] = useState(false);

  const [contactId, setContactId] = useState(null);
  const [showAddEditContact, setShowAddEditContact] = useState(false);

  const [vendorId, setVendorId] = useState(null);
  const [showAddEditVendor, setShowAddEditVendor] = React.useState(false);

  const toggleShowAddEditContact = () => {
    if (showAddEditContact) {
      setEdit(false);
      setOnlyKyc(false);
      setContactId(null);
    }
    setShowAddEditContact(!showAddEditContact);
  };

  const toggleShowAddEditVendor = () => {
    if (showAddEditVendor) {
      setEdit(false);
      setOnlyKyc(false);
      setVendorId(null);
    }
    setShowAddEditVendor(!showAddEditVendor);
  };

  // * End: List Management State

  /**
   * * Start: Fetch Vendor List Form The API
   * @param {Number} passLimit (Number of Limit for each page)
   * @param {Number} passPage (Number of Page for records)
   * @returns {Array} Vendor List
   **/

  const fetchSimplifiedCDDs = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.GET_CDDS}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }&trust_id=${trustId}&cdd=0&cdd_customer_type=${sectionType}&organization_id=${
            organizationData?.organizationId
              ? organizationData?.organizationId
              : ""
          }`,
        );
        setLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const simplifiedCDDsList = data.data.data;
        setSimplifiedCDDsList(simplifiedCDDsList);
        return data.data;
      } catch (error) {
        setSimplifiedCDDsList([]);
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam, sortOrder, sortField, trustId, sectionType, organizationData],
  );

  //* End: Fetch Vendor List Form The API

  const toggleVisual = (id, data) => {
    if (showVisual) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowVisual(!showVisual);
  };

  const toggleRisk = (id, data) => {
    if (showRisk) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowRisk(!showRisk);
  };

  /**
   * * Start: Vendor Table List Record Generation
   * @param {Number} quantity (Number of SimplifiedCDDs)
   * @returns {Array} Vendor List
   **/

  const simplifiedCDDsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      let contact = simplifiedCDDsList[i]?.beneficiary_id
        ? simplifiedCDDsList[i]?.beneficiary
        : simplifiedCDDsList[i]?.vendor_id
          ? simplifiedCDDsList[i]?.vendor
          : simplifiedCDDsList[i]?.contact_id
            ? simplifiedCDDsList[i]?.contact
            : "";
      items.push({
        key: simplifiedCDDsList[i]?.id,
        id: simplifiedCDDsList[i]?.id ? simplifiedCDDsList[i]?.id : "",
        contact_type: simplifiedCDDsList[i]?.beneficiary_id
          ? "Beneficiary"
          : simplifiedCDDsList[i]?.vendor_id
            ? getModuleNamingBySlug(
                organizationData?.organizationData,
                "vendors",
                "Vendor",
              )
            : simplifiedCDDsList[i]?.contact_id
              ? getModuleNamingBySlug(
                  organizationData?.organizationData,
                  "contacts",
                  "Customer",
                )
              : "",
        code: contact?.code ? contact?.code : "",
        name:
          formatName(contact?.first_name, contact?.last_name) +
          (contact?.business_name ? ` (${contact?.business_name})` : ""),
        email: contact?.email,
        phone: contact?.phone ? formatPhone(contact?.phone) : "-",
        mobile: contact?.mobile ? formatMobile(contact?.mobile) : "-",
        risk: (
          <div className="flex items-center gap-2">
            {simplifiedCDDsList[i]?.risk
              ? riskProfile?.find(
                  (item) => item.value == simplifiedCDDsList[i]?.risk,
                )?.label
              : ""}{" "}
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    toggleRisk(
                      simplifiedCDDsList[i]?.id,
                      simplifiedCDDsList[i],
                    );
                  }}
                />
              </span>
            </CustomTooltip>
          </div>
        ),
        source: simplifiedCDDsList[i]?.source
          ? simplifiedCDDsList[i]?.source
          : "KYC Incomplete",
        verifications: simplifiedCDDsList[i]?.verifications
          ? simplifiedCDDsList[i]?.verifications
          : "",
        bureau: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.beneficiary_id
                ? "beneficiary"
                : simplifiedCDDsList[i]?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : simplifiedCDDsList[i]?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"bureau"}
            fetchData={() => fetchSimplifiedCDDs(limit, page)}
          />
        ),
        dvs: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.beneficiary_id
                ? "beneficiary"
                : simplifiedCDDsList[i]?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : simplifiedCDDsList[i]?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"dvs"}
            fetchData={() => fetchSimplifiedCDDs(limit, page)}
          />
        ),
        pep: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.beneficiary_id
                ? "beneficiary"
                : simplifiedCDDsList[i]?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : simplifiedCDDsList[i]?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"pep"}
            fetchData={() => fetchSimplifiedCDDs(limit, page)}
          />
        ),
        sanction: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.beneficiary_id
                ? "beneficiary"
                : simplifiedCDDsList[i]?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : simplifiedCDDsList[i]?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"sanction"}
            fetchData={() => fetchSimplifiedCDDs(limit, page)}
          />
        ),
        adverse_media: (
          <AdverseMedia
            adverse_media_result={
              simplifiedCDDsList[i]?.summaries[0]?.adverse_media_result
            }
            reference_no={simplifiedCDDsList[i]?.summaries[0]?.request_id}
          />
        ),
        risk_assessment_action: (
          <span className="flex items-center gap-2 justify-center">
            {contact?.kyc?.risk_assessment && (
              <>
                <CustomTooltip
                  message={`Assessment Date: ${contact?.kyc?.risk_assessment?.assessment_date}`}
                >
                  <CalendarCheck size={16} />
                </CustomTooltip>
                <span>/</span>
              </>
            )}
            <CustomTooltip message={"Onboarding Assessment"}>
              <SearchCheck
                size={16}
                onClick={() => {
                  setOnlyKyc(true);
                  setEdit(true);
                  if (simplifiedCDDsList[i]?.vendor_id) {
                    toggleShowAddEditVendor();
                    setVendorId(contact?.id);
                  }
                  if (simplifiedCDDsList[i]?.contact_id) {
                    toggleShowAddEditContact();
                    setContactId(contact?.id);
                  }
                }}
              />
            </CustomTooltip>
          </span>
        ),
        kyc: simplifiedCDDsList[i] ? simplifiedCDDsList[i] : "",
        action:
          simplifiedCDDsList[i]?.source !== "Multiple" ? (
            <>
              <span className="flex items-center gap-2 justify-center">
                {simplifiedCDDsList[i]?.kyb_report_file ? (
                  <KYBReportDownload
                    setLoading={setLoading}
                    kyb_report_file={simplifiedCDDsList[i]?.kyb_report_file}
                  />
                ) : (
                  <></>
                )}
                {(simplifiedCDDsList[i]?.kyb_report_file &&
                  simplifiedCDDsList[i]?.status === 1) ||
                simplifiedCDDsList[i]?.verifications[0]?.verified === 1 ? (
                  <Button
                    size={"sm"}
                    className="bg-green-500 hover:bg-green-600 text-white h-6 px-2"
                  >
                    <div className="flex items-center gap-1">
                      <CheckCircle2 size={14} />
                      <span>Verified</span>
                    </div>
                  </Button>
                ) : (simplifiedCDDsList[i]?.kyb_report_file &&
                    simplifiedCDDsList[i]?.status === 1) ||
                  simplifiedCDDsList[i]?.verifications[0]?.verified === 2 ? (
                  <>
                    <Button
                      size={"sm"}
                      className="bg-yellow-500 hover:bg-yellow-600 text-white h-6 px-2"
                    >
                      <div className="flex items-center gap-1">
                        <Clock size={14} />
                        <span>Pending</span>
                      </div>
                    </Button>
                    <CDDVerifyCheck
                      listData={simplifiedCDDsList[i]}
                      setCddId={setCddId}
                      setLoading={setLoading}
                      cddId={cddId}
                      fecthData={fetchSimplifiedCDDs}
                    />
                  </>
                ) : simplifiedCDDsList[i]?.source !== "Visual" ? (
                  simplifiedCDDsList[i]?.source ? (
                    <CDDVerifyModal
                      loading={loading}
                      listData={simplifiedCDDsList[i]}
                      setCddItem={setCddItem}
                      setCddId={setCddId}
                      cddItem={cddItem}
                      customerType={
                        simplifiedCDDsList[i]?.vendor_id
                          ? simplifiedCDDsList[i]?.vendor?.type
                          : simplifiedCDDsList[i]?.contact_id
                            ? simplifiedCDDsList[i]?.contact?.type
                            : 1
                      }
                      setLoading={setLoading}
                      cddId={cddId}
                      sectionType={sectionType}
                      fecthData={fetchSimplifiedCDDs}
                      cdd={0}
                      defaultMobile={
                        simplifiedCDDsList[i]?.vendor_id
                          ? simplifiedCDDsList[i]?.vendor?.mobile
                          : simplifiedCDDsList[i]?.contact_id
                            ? simplifiedCDDsList[i]?.contact?.mobile
                            : ""
                      }
                      defaultABN={
                        simplifiedCDDsList[i]?.vendor_id
                          ? simplifiedCDDsList[i]?.vendor?.abn
                          : simplifiedCDDsList[i]?.contact_id
                            ? simplifiedCDDsList[i]?.contact?.abn
                            : ""
                      }
                    />
                  ) : (
                    "KYC Incomplete"
                  )
                ) : (
                  <CustomTooltip message={"Edit"}>
                    <span>
                      <FontAwesomeIcon
                        icon={faEdit}
                        size="1x"
                        onClick={() => {
                          toggleVisual(
                            simplifiedCDDsList[i]?.id,
                            simplifiedCDDsList[i],
                          );
                        }}
                      />
                    </span>
                  </CustomTooltip>
                )}
              </span>
            </>
          ) : (
            <></>
          ),
      });
    }
    return items;
  };

  const simplifiedCDDs = simplifiedCDDsGenerator(simplifiedCDDsList?.length);

  //* End: Vendor Table List Record Generation

  //* Start: Vendor List Columns

  const columns = [
    {
      dataField: "contact_type",
      text: "Type",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "code",
      text: "Code",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    // {
    //   dataField: "phone",
    //   text: "Phone No.",
    //   sort: true,
    //   sortCaret,
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    // },
    {
      dataField: "mobile",
      text: "Mobile No.",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "risk",
      text: "Risk Profile",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "source",
      text: "Source",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "dvs",
      text: "DVS",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "bureau",
      text: "Bureau",
      headerClasses: THClasses,
      classes: TDClasses,
    },

    {
      dataField: "pep",
      text: "PEP",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "sanction",
      text: "Sanction",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   dataField: "risk_assessment_action",
    //   text: "Onboarding",
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      dataField: "adverse_media",
      text: "Adverse Media",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  //* End: Vendor List Columns

  /**
   * * Start: Vendor List Sorting
   * @param {type} (Sort)
   * @param {JSON} (page, sortField, sortOrder) (To get the current value of the table)
   **/
  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  //* End: Vendor List Sorting

  /**
   * * Start: Vendor List Change Limit
   * @param {Event} e (Limit Number)
   **/
  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchSimplifiedCDDs(limit, 1);
  };

  //* End: Vendor List Change Limit

  /**
   * * Start: Vendor List Change Page
   * @param {Number} page (Page Number)
   **/
  const handleChangePage = (page) => {
    setPage(page);
    fetchSimplifiedCDDs(limit, page);
  };

  //* End: Vendor List Change Page

  //* Start: Vendor List and URL Mangement useEffect

  useEffect(() => {
    fetchSimplifiedCDDs();
  }, [fetchSimplifiedCDDs]);

  //* End: Vendor List and URL Mangement useEffect

  //* Start: Vendor List Search Record Management

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  //* End: Vendor List Search Record Management

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandCDD
          expandList={true}
          expandData={row?.verifications}
          kyc={row?.kyc}
          setLoading={setLoading}
          fetchCDDs={fetchSimplifiedCDDs}
          sectionType={sectionType}
        />
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  return readAccess ? (
    <>
      <MainBody
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        actionContent={<></>}
        loading={loading}
        innerBody={true}
        parentHeight={true}
        mainClassName="w-[calc(100%-3rem)]"
      >
        {/* Vendor Table and Pagination */}
        <div className="custom-table">
          <div className="table-body-class max-h-[52vh] overflow-y-auto">
            <BootstrapTable
              keyField="id"
              remote
              data={simplifiedCDDs}
              columns={columns}
              onTableChange={handleTableChange}
              expandRow={expandRow}
              rowClasses={TRClasses}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
        </div>

        {showVisual && (
          <ResponsiveDrawerForm
            description={""}
            title={`Visual Changes`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleVisual();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showVisual}
            buttonClassName={""}
            setOpen={setShowVisual}
            popupType={"cdds"}
          >
            <VerifyModal
              data={cddItem?.verifications[0]}
              toggleVisual={toggleVisual}
              fetchData={fetchSimplifiedCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {showRisk && (
          <ResponsiveDrawerForm
            description={""}
            title={`Risk Change`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleRisk();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showRisk}
            popupType={"cdds"}
            buttonClassName={""}
            setOpen={setShowRisk}
          >
            <RiskChange
              data={cddItem}
              toggleRisk={toggleRisk}
              fetchData={fetchSimplifiedCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {contactId ? (
          <ResponsiveDrawerForm
            description={""}
            title={
              onlyKyc
                ? `Contact Onboarding Assessment`
                : edit
                  ? `Edit ${getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )}`
                  : `Add ${getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )}`
            }
            handleOpen={() => {}}
            handleClose={() => {
              setEdit(false);
              setOnlyKyc(false);
              setContactId(null);
              setShowAddEditContact(false);
            }}
            buttonText={""}
            className={"overflow-hidden"}
            open={showAddEditContact}
            buttonClassName={""}
            setOpen={setShowAddEditContact}
            write={true}
          >
            <AddEditContact
              edit={edit}
              toggleShowAddEditContact={toggleShowAddEditContact}
              id={contactId}
              setEdit={setEdit}
              onlyKyc={onlyKyc}
              trustId={trustId}
              fetchContactData={() => fetchSimplifiedCDDs(limit, page)}
              org={true}
              amlCTFEnable={amlCTFEnable}
            />
          </ResponsiveDrawerForm>
        ) : vendorId ? (
          <>
            <ResponsiveDrawerForm
              description={""}
              title={
                onlyKyc
                  ? `Vendor Onboarding Assessment`
                  : edit
                    ? `Edit ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )}`
                    : `Add ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )}`
              }
              handleOpen={() => {}}
              handleClose={() => {
                setEdit(false);
                setOnlyKyc(false);
                setVendorId(null);
                setShowAddEditVendor(false);
              }}
              buttonText={""}
              className={"overflow-hidden"}
              open={showAddEditVendor}
              buttonClassName={""}
              setOpen={setShowAddEditVendor}
              mobileCancelHidden={true}
              write={true}
            >
              <AddEditVendor
                edit={edit}
                setEdit={setEdit}
                onlyKyc={onlyKyc}
                toggleShowAddEditVendor={toggleShowAddEditVendor}
                vendorID={vendorId}
                fetchVendors={() => fetchSimplifiedCDDs(limit, page)}
                org={true}
                amlCTFEnable={amlCTFEnable}
              />
            </ResponsiveDrawerForm>
          </>
        ) : (
          <></>
        )}
      </MainBody>
    </>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};

export default SimplifiedCDD;
// * End: Vendor Listing Page
